import * as React from "react";
const SvgLineS = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 15V9", stroke: "white", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export { SvgLineS as ReactComponent };
